import { useEffect, useMemo } from 'react';
import InventoryMapComponent from './inventory_map.component';
import { useNavigate } from 'react-router-dom';

export const InventoryMainComponent = () => {
  const navigate = useNavigate();
  const permissionNames = useMemo(() => {
    try {
      const stored = localStorage.getItem('permissions');
      if (!stored) {
        return [];
      }
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.map((p) => p.name) : [];
    } catch (error) {
      console.error('Failed to parse permissions:', error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (!permissionNames.includes('Inventory')) {
      navigate('/rov', { replace: true });
    }
  }, [permissionNames, navigate]);

  return <InventoryMapComponent />;
};
